import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import WorkerLogin from './components/WorkerLogin';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import MarkAttendance from './components/MarkAttendance';
import SuperAdmin from './components/SuperAdmin';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import View from './components/View';
import AttendancePage from './components/AttendancePage';
import MyPayouts from './pages/MyPayouts.jsx';
import PaymentHistory from './components/PaymentHistory';
import VerifyJob from './components/verifyJob';
import ViewAttendance from './components/ViewAttendance';
import FloorManagerLogin from './components/FloorManagerLogin.jsx';
import SupervisorDashboard from './components/SupervisorDashboard';
import HODActionPage from './components/HODActionPage.jsx';
import ViewWrokerRating from './components/ViewWrokerRating';
import AadharProcessing from './components/AadharProcessing';
import SupervisorRequirements from './components/SupervisorRequirements';
import SuperadminCSV from './components/SuperadminCSV';
import SuperAdminRequestHistory from './components/SuperAdminRequestHistory';
import SuperVisorRating from './components/SuperVisorRating';
import ManageUser from './components/manageUser';
import DailyReport from './components/dailyReport';
import PaymentReport from './components/PaymentReport';
import Metadatapage from './components/managecompanies2/Metadatapage.jsx';
import WorkerOnboardingPage from './pages/workerOnboarding.jsx';
import { SuperAdminProvider } from './context/SuperAdminContext';
import { PaymentProvider } from './context/PaymentContext.jsx'
import { ToastContainer } from "react-toastify";
import PerformanceReport from './pages/performanceReport.jsx';
import MyReferrals from '../src/pages/myReferrals.jsx';
import ReferralPayoutPage from '../src/pages/referralPayout.jsx';
import InsentiveHistoryPage from './pages/InsentivePayout.jsx';
import "react-toastify/dist/ReactToastify.css";
import Payoutlisting from './components/Pages/Payoutlisting.jsx';
import Payoutfile from './components/Pages/Payoutfile.jsx';
import ReferralPayoutFile from './components/Pages/referral_payout_file.jsx';
import MyDetailsPage from './components/MyDetailsPage.jsx';
import SuperAdminLogin from './components/SuperAdmin.jsx';
import HRActionPage from './components/HRActionPage.jsx';
import Supervisorview from './components/Supervisorview.jsx' 
import ManageCampaigns from './components/Campaigns/ManageCampaigns.jsx'

// ── NEW: Tablet QR Scanner ────────────────────────────────────────────────────
import NotificationHistoryPage from './components/NotificationHistoryPage.jsx';
import WorkSummaryPage from "./components/WorkSummaryPage.jsx";
import CompanyDepartmentsPage from './components/CompanyDepartmentPage.jsx';
import TabletScanner from './components/TabletScanner';
import Assigndepartment from './components/Assigndepartment.jsx';

import { ApiProvider } from './context/ApiContext';
import WorkerLayout from './layouts/WorkerLayout';
import AdminLayout from './layouts/AdminLayout';
import SuperAdminLayout from './layouts/SuperAdminLayout';
import FloorManagerLayout from './layouts/FloorManagerLayout';
import ProtectedFloorManagerRoute from './components/ProtectedFloorManagerRoute.jsx';
import AssignDepartmentSuperadmin from './components/Assigndepartmentsuperadmin.jsx';
import WorkerPaymentSetting from './components/WorkerPaymentSetting.jsx';
import WorkerProfilePage from './components/WorkerProfilePage.jsx';
import PaymentHistorySupervisor from './components/PaymentHistorySupervisor.jsx';
import ViewAttendanceAdmin from './components/Viewattendanceadmin.jsx';
import AdminReferralPayoutPage from "./components/AdminReferralPayoutPage.jsx"
import AdminInsentiveHistoryPage from "./components/Admininsentivehistorypage.jsx"
import SupervisorPaymentSetting from "./components/SupervisorPaymentSetting.jsx"
import MyEssentials from "./components/MyEssentials.jsx";
import FaceScanPage from './components/FaceScanPage.jsx';
import ReferAndEarn from './pages/Refer&Earn.jsx'; 
import AdminReferAndEarn from './pages/AdminReferAndEarn.jsx';
import AdminMyReferrals from './pages/AdminMyReferrals.jsx';
import SuperAdminReferAndEarn from './pages/SuperAdminReferAndEarn.jsx';
import ProtectedFeatureRoute from './components/ProtectedFeatureRoute.jsx';

import MyVideos from './components/myVideos.jsx';

const App = () => {
  return (
    <ApiProvider>
    <Router>
      <Routes>
        <Route path="/aadhar-processing" element={<AadharProcessing />} />

        <Route path="/*" element={
          <>
            <ToastContainer />
            <SuperAdminProvider>
              <PaymentProvider>
                <Routes>

                  {/* ── Worker subtree — only WorkerProvider mounts here ── */}
                  <Route element={<WorkerLayout />}>
                    <Route path="/lkart/" element={<WorkerLogin />} />
                    <Route path="/lkart/dashboard" element={
                      <ProtectedRoute><Dashboard /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/view-attendance" element={
                      <ProtectedRoute><AttendancePage /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/my-payouts" element={
                      <ProtectedRoute><MyPayouts /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/payment-history" element={
                      <ProtectedRoute><PaymentHistory /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/my-referrals" element={
  <ProtectedRoute><MyReferrals /></ProtectedRoute>
} />
                    <Route path="/lkart/dashboard/refer-and-earn/:workerType" element={
  <ProtectedRoute><ReferAndEarn /></ProtectedRoute>
} />
                    <Route path="/lkart/dashboard/referral-payout" element={
                      <ProtectedRoute><ReferralPayoutPage /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/incentive-payout" element={
                      <ProtectedRoute><InsentiveHistoryPage /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/my-profile" element={
                      <ProtectedRoute><MyDetailsPage /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/my-store" element={
                       <ProtectedRoute><MyEssentials /></ProtectedRoute>
                  } />
                    <Route path="/lkart/dashboard/notifications" element={
                      <ProtectedRoute><NotificationHistoryPage /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/work-summary" element={
                      <ProtectedRoute><WorkSummaryPage /></ProtectedRoute>
                    } />
                    <Route path="/lkart/dashboard/company-departments" element={
                      <ProtectedRoute><CompanyDepartmentsPage /></ProtectedRoute>
                    } />
                     <Route path="/lkart/dashboard/payment-setting" element={
                      <ProtectedRoute><WorkerPaymentSetting /></ProtectedRoute>
                    } />
                  </Route>
                   
                  

                  {/* ── Admin/supervisor subtree — only AuthProvider mounts here ── */}
                  <Route element={<AdminLayout />}>
  <Route path="/lkart/admin" element={<AdminLogin />} />
  <Route path="/lkart/admin/tablet-scanner" element={
    <ProtectedAdminRoute><TabletScanner /></ProtectedAdminRoute>
  } />
  <Route path="/lkart/attendance" element={
    <ProtectedAdminRoute><MarkAttendance /></ProtectedAdminRoute>
  } />
  <Route path="/lkart/admin/my-referrals" element={
  <ProtectedAdminRoute><AdminMyReferrals /></ProtectedAdminRoute>
} />
  <Route path="/lkart/admin/attendance" element={
    <ProtectedAdminRoute><MarkAttendance /></ProtectedAdminRoute>
  } />
  <Route path="/lkart/admin/tutorials" element={<MyVideos />} />
  <Route path="/lkart/admin/refer-and-earn/:workerType" element={
  <ProtectedAdminRoute><AdminReferAndEarn /></ProtectedAdminRoute>
} />
  <Route path="/lkart/admin/face-scan" element={<FaceScanPage />} />
  <Route path="/lkart/admin/view" element={<ProtectedAdminRoute><Supervisorview /></ProtectedAdminRoute>} />

  <Route path="/lkart/admin/assign" element={<ProtectedAdminRoute><Assigndepartment /></ProtectedAdminRoute>} />
<Route path="/lkart/admin/attendance-history/:id" element={<ProtectedAdminRoute><WorkerProfilePage /></ProtectedAdminRoute>} />
<Route path="/lkart/admin/worker-attendance/:id" element={<ProtectedAdminRoute><AttendancePage /></ProtectedAdminRoute>} />
<Route path="/lkart/admin/worker-payouts/:id" element={<ProtectedAdminRoute><PaymentHistorySupervisor /></ProtectedAdminRoute>} />
<Route path="/lkart/admin/worker-incentive-payouts/:id" element={<ProtectedAdminRoute><AdminInsentiveHistoryPage/></ProtectedAdminRoute>} />
<Route path="/lkart/admin/worker-referral-payouts/:id" element={<ProtectedAdminRoute><AdminReferralPayoutPage /></ProtectedAdminRoute>} />
<Route path="/lkart/admin/payment-mode/:id" element={<ProtectedAdminRoute><SupervisorPaymentSetting/></ProtectedAdminRoute>} />
<Route path="/lkart/admin/view-attendance" element={<ProtectedAdminRoute><ViewAttendanceAdmin/></ProtectedAdminRoute>} />

</Route>

{/* ── Floor manager subtree — only FloorManagerProvider mounts here ── */}
<Route element={<FloorManagerLayout />}>
  <Route path="/lkart/supervisor-login" element={<FloorManagerLogin />} />
  <Route path="/lkart/supervisor/dashboard" element={
    <ProtectedFloorManagerRoute><SupervisorDashboard /></ProtectedFloorManagerRoute>
  } />
  <Route path="/lkart/supervisor/hod/action/:requestId" element={
    <ProtectedFloorManagerRoute><HODActionPage /></ProtectedFloorManagerRoute>
  } />
  <Route path="/lkart/supervisor/requirements" element={
    <ProtectedFloorManagerRoute><SupervisorRequirements /></ProtectedFloorManagerRoute>
  } />
  <Route path="/lkart/supervisor/view-ratings/:id" element={
    <ProtectedFloorManagerRoute><SuperVisorRating /></ProtectedFloorManagerRoute>
  } />
</Route>

                  {/* ── SuperAdmin subtree ── */}
                  <Route element={<SuperAdminLayout />}>
                    <Route path="/lkart/superadmin/payout-listing" element={<PaymentProvider><Payoutlisting /></PaymentProvider>} />
                    <Route path="/lkart/superadmin/payout-file" element={<PaymentProvider><Payoutfile /></PaymentProvider>} />
                    <Route path="/lkart/superadmin/referral-payout-file" element={<PaymentProvider><ReferralPayoutFile /></PaymentProvider>} />
                    <Route path="/lkart/superadmin/login" element={<SuperAdminLogin />} />

                    <Route path="/lkart/superadmin/*" element={
                      <Routes>
                        <Route path="/" element={<SuperAdmin />} />
                        <Route path="/view" element={<View />} />
                        <Route path="/dashboard" element={<SuperAdminDashboard />} />
                        <Route path="/upload-csv" element={<SuperadminCSV />} />
                        <Route path="/view-attendance" element={<ViewAttendance />} />
                        <Route path="/request-history" element={<SuperAdminRequestHistory />} />
                        <Route path="/manageUser" element={<ManageUser />} />
                        <Route path="/refer-and-earn" element={<SuperAdminReferAndEarn />} />
                        <Route path="/daily-report" element={<DailyReport />} />
                        <Route path="/payment-report" element={<PaymentReport />} />
                        <Route path="/manage-metadata" element={<Metadatapage />} />
                        <Route path="/assign" element={<AssignDepartmentSuperadmin />} />
                        <Route path="/worker-onboarding" element={<WorkerOnboardingPage />} />
                         <Route path="/campaigns" element={
        <ProtectedFeatureRoute anyOf={["Office Team"]}><ManageCampaigns /></ProtectedFeatureRoute>
      } />
                        <Route path="/attendance-history/:id" element={<ViewWrokerRating />} />
                        <Route path="/performance-report" element={<PerformanceReport />} />
                        <Route path="/hr/action/:requestId" element={<HRActionPage />} />
                      </Routes>
                    } />
                  </Route>

                </Routes>
              </PaymentProvider>
            </SuperAdminProvider>
          </>
        } />
      </Routes>
    </Router>
    </ApiProvider>
  )
}

export default App
